import React, { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

type PriceProviderContext = {
  currency: string,
  showCurrencySign: boolean,
};

const PriceContext = createContext<PriceProviderContext | undefined>(undefined);

type Props = PriceProviderContext & {
  children: ReactNode,
};

const PriceProvider = ({ currency, showCurrencySign = true, children }: Props) => {
  const value = useMemo(() => ({ currency, showCurrencySign }), [currency, showCurrencySign]);

  return <PriceContext.Provider value={value}>{children}</PriceContext.Provider>;
};

const usePriceContext = () => {
  const context = useContext(PriceContext);

  if (context === undefined) {
    throw new Error('usePriceContext must be used within PriceProvider');
  }

  return context;
};

export type { PriceProviderContext };
export { PriceProvider, usePriceContext };
